module.exports = __webpack_public_path__ + "static/StaffArgumentation-e12ab0c3b76269798e21809ca4e12f42.png";